import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddTablePriority1729849382684 implements MigrationInterface {
	name = 'AddTablePriority1729849382684'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`CREATE TYPE "public"."table_priority_enum" AS ENUM('low', 'normal', 'high')`)
		await queryRunner.query(
			`ALTER TABLE "table" ADD "priority" "public"."table_priority_enum" NOT NULL DEFAULT 'normal'`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "table" DROP COLUMN "priority"`)
		await queryRunner.query(`DROP TYPE "public"."table_priority_enum"`)
	}
}
